module.exports = __webpack_public_path__ + "static/media/logo_dark.89e39a80.svg";